import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { FormOfPaymentTypeSort, FormOfPaymentTypeUpdateSortSequence } from "src/app/core/models/form-of-payment-model";
import { FormOfPaymentTypeReferenceService } from "src/app/core/services/system-services/form-of-payment-type-reference.service";

@Injectable({
    providedIn: 'root'
})
export class FormOfPaymentTypeSortService {

    private _formOfPaymentTypes$ = new BehaviorSubject<FormOfPaymentTypeSort[]>([])
    private _callSort$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()
    private _updateSort$ = new Subject()

    get formOfPaymentTypes$() {
        return this._formOfPaymentTypes$.asObservable()
    }
    get callSort$() {
        return this._callSort$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }
    get updateSort$() {
        return this._updateSort$.asObservable()
    }

    constructor(private formOfPaymentTypeReference: FormOfPaymentTypeReferenceService
    ) {
    }

    getFormOfPaymentTypesSort(): Observable<FormOfPaymentTypeSort[]> {
        return this.formOfPaymentTypeReference.getSort()
            .pipe(
                tap(response => this._formOfPaymentTypes$.next(response))
            )
    }

    updateSortSequence(items: FormOfPaymentTypeUpdateSortSequence[]): Observable<never> {
        return this.formOfPaymentTypeReference.updateSortSequence(items)
    }

    clearLocationGroupsSort() {
        this._formOfPaymentTypes$.next([])
    }
    callSort() {
        this._callSort$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }
    updateSort() {
        this._updateSort$.next()
    }
}
